import React from "react";
import { cn } from "../../lib/utils";
import type { MapCustomMapsLibraryPageProps } from "../../contracts/map-custom-maps";

export function MapCustomMapsLibraryPage({
  hero,
  toolbar,
  content,
  className,
}: MapCustomMapsLibraryPageProps) {
  return (
    <div className={cn("flex flex-col min-h-full bg-background", className)}>
      <div className="flex-1 w-full max-w-[1600px] mx-auto p-4 md:p-8 space-y-8">
        {hero && (
          <section aria-label="Library Overview">
            {hero}
          </section>
        )}
        
        <div className="flex flex-col gap-8">
          {toolbar && (
            <section aria-label="Library Refinement" className="sticky top-4 z-20">
              {toolbar}
            </section>
          )}
          
          <main aria-label="Map Collection">
            {content}
          </main>
        </div>
      </div>
    </div>
  );
}
